export const createDigitalSignSlice = (set) => ({
  isLoading: false,
  searchKeyWord: '',
  setSearchKeyWord: (keyWord) => {
    set((state) => {
      state.digitalSign.searchKeyWord = keyWord;
    });
  },
  setIsLoading: (isLoading) => {
    set((state) => {
      state.digitalSign.isLoading = isLoading;
    });
  },
  resetDigitalSignSlice: () => {
    set((state) => {
      state.digitalSign.searchKeyWord = '';
      state.digitalSign.isLoading = false;
    });
  },
});
